import { Link } from 'react-router-dom';
import { Reveal } from '../components/ui';

interface ServiceCard {
  eyebrow?: string;
  heading?: string;
  body?: string;
  ctaLabel?: string;
  ctaHref?: string;
}

interface ServicesDuoData {
  concierge?: ServiceCard;
  laundry?: ServiceCard;
}

/** The cream band pairing Concierge and Laundry — the one light section in the design. */
export function ServicesDuoBlock({ data }: { data: ServicesDuoData }) {
  const cards = [data.concierge, data.laundry].filter(Boolean) as ServiceCard[];
  if (cards.length === 0) return null;

  return (
    <section className="sz-services">
      <div className="sz-services__inner">
        {cards.map((card, index) => (
          <Reveal key={card.ctaHref ?? index} delay={index * 90}>
            <p className="sz-services__eyebrow">{card.eyebrow}</p>
            <h3 className="sz-services__heading">{card.heading}</h3>
            <p className="sz-services__body">{card.body}</p>
            {card.ctaHref && (
              <Link to={card.ctaHref} className="sz-btn sz-btn--dark">
                {card.ctaLabel}
              </Link>
            )}
          </Reveal>
        ))}
      </div>
    </section>
  );
}
